import { FC } from "react";
// import cx from 'classnames';

const PricayPolicy: FC = () => {
  return (
    <div className="pt-25 pb-15 md:pt-50">
      <p className="text-dark text-4xl leading-tight font-light">
        Privatumo politika
      </p>
      <br />
      <p className="text-dark text-xl leading-tight font-normal">
        TELOMERA ASMENS DUOMENŲ TVARKYMO TAISYKLĖS – PRIVATUMO POLITIKA
      </p>
      <br />
      <p>
        Klientų asmens duomenų tvarkymo taisyklės (toliau – Taisyklės)
        reglamentuoja klientų asmens duomenų rinkimo, naudojimo ir saugojimo
        principus, nustato klientų asmens duomenų tvarkymo tikslus ir priemones,
        nustato, kas ir kokiais tikslais, gali susipažinti su klientų asmens
        duomenimis.
      </p>
      <br />
      <h4>SĄVOKOS</h4>
      <br />
      <p>
        Atsakingas asmuo – fizinis ar juridinis asmuo pagal paslaugų ar kitą
        sutartį Įmonės paskirtas tvarkyti klientų asmens duomenis;
      </p>
      <br />
      <p>
        Įmonė – Telomera.LT, UAB, 305022637 (Žeimių g. 6B-26, Ginkūnų k.,
        LT-81486 Šiaulių r., +37063988229, info@telomera.lt)
      </p>
      <br />
      <p>
        Kitos šiose Taisyklėse vartojamos sąvokos yra suprantamos taip, kaip jos
        apibrėžtos Lietuvos Respublikos asmens duomenų teisinės apsaugos
        įstatyme ir kituose asmens duomenų tvarkymą reglamentuojančiuose teisės
        aktuose. Pagrindinės sąvokos yra šios:
      </p>
      <br />
      <p>
        Asmens duomenys – bet kuri informacija, susijusi su fiziniu asmeniu –
        duomenų subjektu, kurio tapatybė yra žinoma, arba gali būti tiesiogiai
        ar netiesiogiai nustatyta pasinaudojant tokiais duomenimis kaip asmens
        kodas, vienas arba keli asmeniui būdingi fizinio, fiziologinio,
        psichologinio, ekonominio, kultūrinio ar socialinio pobūdžio požymiai.
      </p>
      <br />
      <p>
        Duomenų tvarkymas – bet kuris su asmens duomenimis atliekamas veiksmas:
        rinkimas, užrašymas, kaupimas, saugojimas, klasifikavimas, grupavimas,
        jungimas, keitimas (papildymas ar taisymas), teikimas, paskelbimas,
        naudojimas, loginės ir (ar) aritmetinės operacijos, paieška, skleidimas,
        naikinimas ar kitoks veiksmas arba veiksmų rinkinys.
      </p>
      <br />
      <p>
        Trečiasis asmuo – juridinis ar fizinis asmuo, išskyrus duomenų subjektą,
        duomenų valdytoją, duomenų tvarkytoją ir asmenis, kurie yra tiesiogiai
        duomenų valdytojo ar duomenų tvarkytojo įgalioti tvarkyti duomenis.
      </p>
      <br />
      <h4>II SKYRIUS</h4>
      <br />
      <h4>KLIENTŲ ASMENS DUOMENŲ TVARKYMO PRINCIPAI</h4>
      <br />
      <p>
        Įmonė, tvarkydama klientų asmens duomenis, vadovaujasi šiais principais:
      </p>
      <br />
      <ul>
        <li>
          klientų asmens duomenis tvarko tik teisėtiems ir šiose Taisyklėse
          apibrėžtiems tikslams pasiekti;
        </li>
        <li>
          klientų asmens duomenys yra tvarkomi tiksliai, sąžiningai ir teisėtai,
          laikantis teisės aktų reikalavimų.
        </li>
        <li>
          Įmonė klientų asmens duomenis tvarko taip, kad asmens duomenys nuolat
          būtų tikslūs ir esant jų pasikeitimui nuolat atnaujinami;
        </li>
        <li>
          Įmonė atlieka klientų asmens duomenų tvarkymą tik ta apimtimi, kuri
          yra reikalinga klientų asmens duomenų tvarkymo tikslams pasiekti;
        </li>
        <li>
          klientų asmens duomenys saugomi tokia forma, kad duomenų subjektų
          tapatybę būtų galima nustatyti ne ilgiau, negu to reikia tiems
          tikslams, dėl kurių šie duomenys buvo surinkti ir tvarkomi;
        </li>
        <li>Asmens duomenys tvarkomi tiksliai, sąžiningai ir teisėtai.</li>
      </ul>
      <br />
      <h4>III SKYRIUS</h4>
      <br />
      <h4>KLIENTŲ ASMENS DUOMENŲ TVARKYMO TIKSLAI</h4>
      <br />
      <p>
        Klientų asmens duomenų tvarkymo išsami informacija pateikiama šioje
        politikoje.
      </p>
      <br />
      <p>
        Pagrindiniai tvarkomi asmens duomenys: vardas, pavardė, telefono
        numeris, el. paštas ir kiti duomenys, reikalingi užsakymams įgyvendinti,
        marketinginiams pasiūlymams pateikti.
      </p>
      <br />
      <p>Pagrindiniai asmens duomenų tvarkymo tikslai:</p>
      <br />
      <p>
        Užsakymų tvarkymas ir įgyvendinimas, vartotojų duomenų, pirkimų ir
        naudojimosi puslapiu analizė vartotojų patirties ir tinklalapio
        tobulinimo tikslais, rinkodaros, reklamos tikslais.
      </p>
      <br />
      <h4>IV SKYRIUS</h4>
      <br />
      <h4>DUOMENŲ SUBJEKTO TEISĖS</h4>
      <br />
      <p>
        Įmonė paskiria atsakingą asmenį, kuris užtikrina, kad klientų, kaip
        duomenų subjektų, teisės būtų užtikrintos, tinkamai įgyvendinamos ir
        visa informacija būtų pateikiama tinkamai, laiku ir darbuotojams
        priimtina forma.
      </p>
      <br />
      <p>
        Klientų, kaip duomenų subjektų, teisės ir jų įgyvendinimo priemonės:
      </p>
      <br />
      <ul>
        <li>
          Žinoti apie savo asmens duomenų rinkimą. Įmonė, rinkdama kliento
          asmens duomenis, privalo informuoti šiuos asmenis, kokius asmens
          duomenis klientas turi pateikti, kokiu tikslu atitinkami duomenys yra
          renkami, kam ir kokiu tikslu jie gali būti teikiami ir kokios asmens
          duomenų nepateikimo pasekmės. Supaprastinta informacija yra pateikiama
          kliento sutikimuose. Klientas turi teisę susipažinti su savo asmens
          duomenimis, reikalauti ištaisyti, patikslinti ar papildyti neteisingus
          ar neišsamius jo asmens duomenis. Klientas taip pat gali nesutikti,
          kad būtų tvarkomi tam tikri neprivalomi jo asmens duomenys.
        </li>
        <li>
          Susipažinti su savo asmens duomenimis ir kaip jie yra tvarkomi.
          Klientas turi teisę kreiptis į Įmonę su prašymu pateikti informaciją
          apie tai, kokie ir kokiu tikslu jo asmens duomenys yra tvarkomi. Vieną
          kartą per Klientui ši informacija pateikiama nemokamai. Jeigu klientas
          kreipiasi daugiau nei vieną kartą per metus dėl tokios informacijos
          pateikimo, mokestis už šios informacijos pateikimą negali viršyti
          tokios informacijos pateikimo sąnaudų.
        </li>
        <li>
          Reikalauti ištaisyti, sunaikinti savo asmens duomenis arba sustabdyti
          savo asmens domenų tvarkymą.
        </li>
        <li>
          Nesutikti, kad būtų tvarkomi asmens duomenys. Klientas turi teisę
          nesutikti, kad būtų tvarkomi tam tikri neprivalomi jo asmens duomenys.
          Toks nesutikimas gali būti išreikštas neužpildant tam tikrų anketos ar
          kitų pildomų dokumentų skilčių, taip pat vėliau pateikiant prašymą dėl
          neprivalomai tvarkomų asmens duomenų tvarkymo nutraukimo. Įmonė
          suteikia informaciją raštu, kokie asmens duomenys yra tvarkomi
          neprivalomai. Įmonė, gavusi prašymą nutraukti neprivalomai tvarkomų
          asmens duomenų tvarkymą, nedelsiant nutraukia tokį tvarkymą, nebent
          tai prieštarauja teisės aktų reikalavimams ir apie tai informuoja
          darbuotoją/klientą.
        </li>
      </ul>
      <br />
      <h4>V SKYRIUS</h4>
      <br />
      <h4>ASMENS DUOMENŲ SAUGUMO UŽTIKRINIMO PRIEMONĖS</h4>
      <br />
      <p>
        Prieigos teisės prie asmens duomenų ir įgaliojimai tvarkyti asmens
        duomenis suteikiami, naikinami ir keičiami Įmonės vadovo įsakymu.
      </p>
      <br />
      <p>
        Įmonė, saugodama asmens duomenis, įgyvendina ir užtikrina tinkamas
        organizacines ir technines priemones, skirtas apsaugoti asmens duomenims
        nuo atsitiktinio ar neteisėto sunaikinimo, pakeitimo, atskleidimo, taip
        pat nuo bet kokio kito neteisėto tvarkymo.
      </p>
      <br />
      <p>
        Įmonė užtikrina tinkamą dokumentų bei duomenų rinkmenų saugojimą, imasi
        priemonių, kad būtų užkirstas kelias atsitiktiniam ar neteisėtam asmens
        duomenų sunaikinimui, pakeitimui, atskleidimui, taip pat bet kokiam
        kitam neteisėtam tvarkymui. Dokumentų kopijos, kuriose nurodomi
        darbuotojų asmens duomenys, turi būti sunaikintos taip, kad šių
        dokumentų nebūtų galima atkurti ir atpažinti jų turinio.
      </p>
      <br />
      <p>
        Įmonėje su asmens duomenimis turi teisę susipažinti tik tie asmenys,
        kurie buvo įgalioti susipažinti su tokiais duomenimis, ir tik tuomet,
        kai tai yra būtina šiose Taisyklėse numatytiems tikslams pasiekti.
      </p>
      <br />
      <p>
        Įmonė užtikrina patalpų, kuriose laikomi asmens duomenys, saugumą,
        tinkamą techninės įrangos išdėstymą ir peržiūrą, priešgaisrinės saugos
        taisyklių laikymąsi, tinkamą tinklo valdymą, informacinių sistemų
        priežiūrą bei kitų techninių priemonių, būtinų asmens duomenų apsaugai
        užtikrinti, įgyvendinimą.
      </p>
      <br />
      <p>
        Įmonė imasi priemonių, kad būtų užkirstas kelias atsitiktiniam ar
        neteisėtam asmens Duomenų sunaikinimui, pakeitimui, atskleidimui, taip
        pat bet kokiam kitam neteisėtam tvarkymui, saugodama jai patikėtus
        dokumentus bei duomenų rinkmenas tinkamai ir saugiai.
      </p>
      <br />
      <p>
        Jei duomenis tvarkantis darbuotojas ar kitas atsakingas asmuo abejoja
        įdiegtų saugumo priemonių patikimumu, jis turi kreiptis į tiesioginį
        savo vadovą, kad būtų įvertintos turimos saugumo priemonės ir, jei
        reikia, inicijuotas papildomų priemonių įsigijimas ir įdiegimas.
      </p>
      <br />
      <p>
        Darbuotojai ar kiti atsakingi asmenys, kurie automatiniu būdu tvarko
        asmens duomenis arba iš kurių kompiuterių galima patekti į vietinio
        tinklo sritis, kuriose yra saugomi asmens duomenys, naudoja jiems
        priskirtus slaptažodžius. Slaptažodžiai yra keičiami susidarius tam
        tikroms aplinkybėms (pvz.: pasikeitus darbuotojui, iškilus įsilaužimo
        grėsmei, kilus įtarimui, kad slaptažodis tapo žinomas tretiesiems
        asmenims, ir pan.).
      </p>
      <br />
      <p>
        Darbuotojas, dirbantis konkrečiu kompiuteriu, ir prieinantis prie asmens
        duomenų gali žinoti tik savo slaptažodį. Slaptažodžiai saugomi saugioje
        vietoje ir naudojami tik būtinu atveju.
      </p>
      <br />
      <p>
        Nustačius asmens duomenų saugumo pažeidimus, Įmonė imasi neatidėliotinų
        priemonių užkertant kelią neteisėtam asmens duomenų tvarkymui.
      </p>
      <br />
      <p>
        Šių Taisyklių nesilaikymas atsižvelgiant į pažeidimo sunkumą, kai jų
        nesilaikė darbuotojas gali būti laikomas darbo pareigų pažeidimu, už
        kurį darbuotojams gali būti taikoma atsakomybė, numatyta Lietuvos
        Respublikos darbo kodekse.
      </p>
      <br />
      <h4>VI SKYRIUS</h4>
      <br />
      <h4>BAIGIAMOSIOS NUOSTATOS</h4>
      <br />
      <p>
        Šios Taisyklės peržiūrimos ir atnaujinamos pasikeitus teisės aktams,
        kurie reglamentuoja asmens duomenų tvarkymą.
      </p>
      <br />
      <p>
        Darbuotojai ir kiti atsakingi asmenys su šiomis Taisyklėmis yra
        supažindinami pasirašytinai arba elektroninėmis priemonėmis ir privalo
        laikytis joje nustatytų įpareigojimų bei atlikdami savo darbo funkcijas
        vadovautis šiose Taisyklėse nustatytais principais. Klientui paprašius
        jiems yra suteikiama galimybė susipažinti su šiomis Taisyklėmis.
      </p>
      <br />
      <p>
        Įmonė turi teisę iš dalies arba visiškai pakeisti šias Taisykles. Su
        pakeitimais darbuotojai ir kiti atsakingi asmenys yra supažindinami
        pasirašytinai arba elektroninėmis priemonėmis
      </p>
      <br />
      <p>Jei turite klausimų, susisiekite info@telomera.lt</p>
      <br />
    </div>
  );
};

export default PricayPolicy;
